import { axios } from 'utils/axios';
import { TokenAccount } from 'types/AiSubscription';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

const getTokenAccount = async (): Promise<TokenAccount> => {
  const { data } = await axios.get<TokenAccount>('/token/token-account');
  return data;
};

export const useTokenAccount = (): UseQueryResult<TokenAccount, unknown> => {
  return useQuery({
    queryKey: ['token-account'],
    queryFn: getTokenAccount,
  });
};
